// extracted by mini-css-extract-plugin
export default {"profileWrapper":"reportList_profileWrapper__svgk5","reportQuestion":"reportList_reportQuestion__nIrTB"};